import { fetchPageAssets } from '../../ducks/hostedAssets.duck';
import {
  ASSET_NAME,
  searchCollectiblesListings,
  searchFeaturedListings,
  searchRecentListings,
} from '../LandingPage/LandingPage.duck';



// ================ Page asset loader ================ //
export const loadData = (params, search, config) => async (dispatch, getState, { sdk }) => {
  const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };

  dispatch(searchFeaturedListings(config));
  dispatch(searchRecentListings(config));
  return Promise.all([
    dispatch(searchCollectiblesListings(config)),
    dispatch(fetchPageAssets(pageAsset, true)),
  ]);
};
